import { useCallback } from 'react';
import type { EventsExportControls } from '@/hooks';
import { useQueryResultsStore } from '@/stores';

interface UseQueryEventsExportResult {
    busy: boolean;
    startExport: () => Promise<void>;
}

export function lastQueryExportName(): string {
    return useQueryResultsStore.getState().lastQueryParams?.text ?? '';
}

export function useQueryEventsExport(
    eventExport: EventsExportControls,
): UseQueryEventsExportResult {
    const { busy, startExport } = eventExport;

    const startSelectedExport = useCallback(async () => {
        const { selectedEventIds } = useQueryResultsStore.getState();
        await startExport(Array.from(selectedEventIds));
    }, [startExport]);

    return { busy, startExport: startSelectedExport };
}
